import { axiosInstanceConversationalEngine } from "../instance"
import { HandleMessagePayload, PromptGeneratorResponse } from "./types"

export const createPromptGeneratorPayload = (adText: string, includeJsonParser: boolean = false): HandleMessagePayload => {
    const payload: HandleMessagePayload = {
        query: "",
        agent_id: "ad_prompt_generator",
        parameter_prompt: {
            ad_text: adText
        },
        conversation_id: "",
        metadata_filter: null
    };

    if (includeJsonParser) {
        payload.json_parser = {
            gender: "string",
            ad_text: "string"
        };
    }

    return payload;
}

export const promptGenerator = async (adText: string) => {
    const payload = createPromptGeneratorPayload(adText, false);
    const response = await axiosInstanceConversationalEngine.post('/handle-message', payload);
    return response.data; 
}

export const promptGeneratorJson = async (adText: string): Promise<PromptGeneratorResponse> => {
    const payload = createPromptGeneratorPayload(adText, true);
    const response = await axiosInstanceConversationalEngine.post<PromptGeneratorResponse>('/handle-message-json', payload);
    return response.data;
}

